import { getAllTranspiledData } from '../../data/apis/api';
import { useRestQuery } from '../../data/util';
import { QueryKey } from './config';

export const useAllTranspiledData = (transpilerId: string, isBulk?: boolean, disabled?: boolean) => {
  const data = useRestQuery(
    [QueryKey, 'getAllTranspiledData', transpilerId],
    () => getAllTranspiledData(transpilerId, isBulk),
    {
      retry: false,
      refetchOnMount: true,
      refetchOnWindowFocus: false,
      enabled: !!transpilerId && !disabled,
      sentryTag: 'transpiler.getAllTranspiledData'
    }
  );

  return data;
};
